module.exports = __webpack_public_path__ + "img/WLGHZX_2.d44df7e0.jpg";